export function authenticAuthPasswordStrengthValidator(value) {
  // See https://github.com/mytours/authentic-auth/blob/1c688acb4194959a322a6356756637085fca5eb1/app/validators/password_validator.rb#L4

  if (!value || value.trim() === "") {
    return false;
  }

  const upperCasePattern = /[A-Z]/g;
  const lowerCasePattern = /[a-z]/g;
  const numberPattern = /[0-9]/g;
  const specialCharPattern = /[^A-Za-z0-9]/g;

  return (
    upperCasePattern.test(value) &&
    lowerCasePattern.test(value) &&
    numberPattern.test(value) &&
    specialCharPattern.test(value)
  );
}

export function authenticAuthPasswordLengthValidator(value) {
  // > config.password_length = 14..128
  // See https://github.com/mytours/authentic-auth/blob/1c688acb4194959a322a6356756637085fca5eb1/config/initializers/devise.rb#L184

  return value.length >= 14 && value.length <= 128;
}



// WEBPACK FOOTER //
// ./webapp/utils/validations.js